import "./Home_SectionTwo.scss";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getSlide } from "../../../services/home/home";
import { Button, Col, Row } from "antd";

function Home_SectionTwo() {
  const [slide, setSlide] = useState([]);

  useEffect(() => {
    const fetchApi = async () => {
      const contentSlide = await getSlide();
      setSlide(contentSlide);
      // console.log(contentSlide);
    };
    fetchApi();
  }, []);

  return (
    <>
      <div className="home-sectionTwo">
        <div className="container">
          <div className="home-sectionTwo-wrapper">
            {slide.length > 0 && (
              <Splide
                options={{
                  type: "loop",
                  perPage: 1,
                  gap: "30px",
                  arrows: false,
                  pagination: true,
                  speed: 900,
                  easing: "ease-in-out",
                  interval: 3000,
                  autoplay: true,
                  resetProgress: true,
                  pauseOnHover: true,
                }}
              >
                {slide.map((item) => (
                  <SplideSlide key={item.id}>
                    <Row className="slide">
                      <Col xxl={10} xl={10} lg={10} md={10} sm={24}>
                        <div className="slide-item-left">
                          <div className="title">{item.title}</div>
                          <div className="sub">{item.sub}</div>
                          <Link to="products">
                            <Button>Mua ngay</Button>
                          </Link>
                        </div>
                      </Col>

                      <Col xxl={14} xl={14} lg={14} md={14} sm={24}>
                        <div className="slide-item-right">
                          <img src={item.thumbnail} alt="Slide" />
                        </div>
                      </Col>
                    </Row>
                  </SplideSlide>
                ))}
              </Splide>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Home_SectionTwo;
